import { ITrackingEvent } from "@swyft/swyft-common";
import classNames from "classnames";
import {
  buildSteps,
  buildSummary,
  IMerchantDetails,
} from "~/helpers/components/steps/step";
import Step from "~/components/shipping/steps/step";

interface StepsProps {
  isSummary?: boolean;
  merchant: IMerchantDetails;
  events: ITrackingEvent[];
  timezone?: string;
}

const Steps = (props: StepsProps) => {
  const { isSummary = false, events, merchant, timezone } = props;

  const steps = isSummary
    ? buildSummary(events, merchant)
    : buildSteps(events, merchant);

  const className = classNames("shipping-steps", {
    summary: isSummary,
  });

  return (
    <div className={className}>
      {steps.map((step, index) => {
        return (
          <Step
            isSummary={isSummary}
            data={step}
            key={index}
            final={index === steps.length - 1}
            timezone={timezone}
          />
        );
      })}
    </div>
  );
};

export default Steps;
